<template>
    <!-- 결제정보 자동 등록 팝업 -->
    <div v-show='show' class='layer-pop square-type'>
        <div class='view-content' style='width: 640px;'>
            <button class='close' @click='onClosePop'><span class='blind'>팝업 닫기</span></button>
            <div class="px-6">
              <p class='sub-title mb-4'>
                {{editable ? '반려 사유 작성' : '반려 사유 확인'}}
              </p>
            </div>
            
            <div class="px-6">
              <div class='scroll-area com-scroll-y px-0 text_area'>
                <textarea 
                  class="com-textarea" 
                  maxlength='200'
                  :disabled="!editable" 
                  :placeholder="editable ? '반려 사유를 작성해주세요.(최소 5자)' : ''"
                  v-model="data">
                </textarea>
              </div>
              <p class="text-right text-muted">{{data.length}} / 200</p>
            </div>
            

            <div class='bottom-btn mt-8'>
              <template v-if="editable">
                <button class='com-btn' @click='onClosePop'>취소</button>
                <button class='com-btn blue' :disabled="data.length < 5" @click='onSubmit'>반려</button>
              </template>
              <button v-else class='com-btn blue' @click='onClosePop'>확인</button>
            </div>
        </div>
    </div>
</template>

<script>
import LoadingSpinner from '@/components/LoadingSpinner';

export default {
  name: 'RejectReasonDlg',
  components: { LoadingSpinner },
  props: {
    content: String,
    show: Boolean,
    editable: Boolean,
    close: Function,
    confirm: Function
  },
  data() {
    return {
      loading: false,
      data: '',
    };
  },
  watch: {
    show(){
      this.data = this.content || ''
    }
  },
  methods: {
    onClosePop() {
      this.close();
    },

    onSubmit(){
      this.confirm(this.data)
    },
  },
};
</script>
<style scoped>
  .text_area{
    max-height: 320px;
    min-height: 320px;

    textarea{
      min-height: 320px;
      resize: none;
    }
  }
</style>
